import classNames from 'classnames';
import { ExternalLink } from 'lucide-react';

interface DisclaimerProps {
  className?: string;
}

function Disclaimer({ className }: DisclaimerProps) {
  return (
    <div className={classNames('gap-xs flex flex-col items-end', className)}>
      <p className="text-disclaimer text-description">
        The contents of this document or any prior or subsequent communications
        from TreasurySpring or any of its directors, officers, employees or
        agents, is not and shall not be construed as legal, investment, credit,
        financial or any other form of advice. This document is provided for
        information purposes only, on a non-reliance basis and should not form
        the basis of any investment decision.
      </p>

      <a
        href="https://treasuryspring.com/hubfs/rate-card-disclaimer-2026.pdf"
        target="_blank"
        rel="noreferrer"
        className="text-link-small gap-xxs flex flex-nowrap items-center"
      >
        Full disclaimer
        <ExternalLink className="size-s" />
      </a>
    </div>
  );
}

export default Disclaimer;
